import Link from '@tiptap/extension-link';
import { NodeSelection } from '@tiptap/pm/state';

import { cn } from '@common/utils';

export interface CustomLinkOptions {
  href: string;
  theme:
    | 'text'
    | 'primary-fill-button'
    | 'sub-fill-button'
    | 'blue-fill-button'
    | 'image';
  isOutLink: boolean;
  /** 버튼 형식에만 영향을 줌 */
  size: 'H56' | 'H40';
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    customLink: {
      setCustomLink: (options: CustomLinkOptions) => ReturnType;
    };
  }
}

export const CustomLink = Link.configure({
  autolink: false,
  openOnClick: false,
  protocols: ['http', 'https'],
  linkOnPaste: false,
}).extend({
  addAttributes() {
    return {
      ...this.parent?.(),
    };
  },
  addCommands() {
    return {
      ...this.parent?.(),
      setCustomLink:
        ({ href, theme, size, isOutLink }) =>
        ({ chain, state }) => {
          const { selection } = state;
          const { from, to } = selection;

          const updateImageAttributes = () => {
            return chain()
              .updateAttributes('image', {
                href,
                target: '_blank',
                rel: 'noopener noreferrer',
              })
              .run();
          };

          // 이미지 노드가 선택되었는지 확인
          const isImageSelected =
            selection instanceof NodeSelection &&
            selection.node.type.name === 'image';

          if (isImageSelected) {
            return updateImageAttributes();
          }

          switch (theme) {
            case 'image':
              return updateImageAttributes();

            case 'primary-fill-button':
            case 'sub-fill-button':
            case 'blue-fill-button':
              return chain()
                .extendMarkRange('link')
                .unsetMark('link')
                .setMark('link', {
                  href,
                  class: cn(
                    'cursor-pointer inline-block rounded-medium font-700',
                    {
                      H56: 'py-16 px-24 typo-body3',
                      H40: 'py-9 px-16 typo-body4',
                    }[size],
                    {
                      'primary-fill-button': 'bg-Gray-black text-Gray-white',
                      'sub-fill-button': 'bg-Gray-200 text-Gray-black',
                      'blue-fill-button': 'bg-B-500 text-Gray-white',
                    }[theme],
                  ),
                  rel: isOutLink ? 'noopener noreferrer' : undefined,
                  target: isOutLink ? '_blank' : '_self',
                })
                .setTextSelection({ from, to })
                .run();

            case 'text':
              return chain()
                .extendMarkRange('link')
                .unsetMark('link')
                .setMark('link', {
                  href,
                  class: 'cursor-pointer hover:underline text-B-500 font-500',
                  rel: isOutLink ? 'noopener noreferrer' : undefined,
                  target: isOutLink ? '_blank' : '_self',
                })
                .setTextSelection({ from, to })
                .run();
          }
        },
    };
  },

  addPasteRules() {
    return [];
  },
});
